import { ClientEnvironment } from '@polyai/common/constants/global.constants';

import api from 'api';

// Environment keys used by integration routing forms (matches API schema)
export enum ROUTING_ENVIRONMENTS {
  PRE_RELEASE = 'prerelease',
  LIVE = 'live',
  SANDBOX = 'sandbox',
}

export type NumbersByEnvironment = Record<ROUTING_ENVIRONMENTS, string[]>;

const EMPTY_NUMBERS: NumbersByEnvironment = {
  [ROUTING_ENVIRONMENTS.LIVE]: [],
  [ROUTING_ENVIRONMENTS.PRE_RELEASE]: [],
  [ROUTING_ENVIRONMENTS.SANDBOX]: [],
};

// Creates a form data source that fetches phone numbers for a given telephony
// integration and groups them by environment (sandbox, prerelease, live).
// Use for integration forms that need to pre-populate routing number fields.
export const createPhoneNumbersDataSource =
  (integrationId: string) => async (accountId: string, projectId: string) => {
    const numbers = await api.getPhoneNumbersInAllEnvironments(
      accountId,
      projectId,
    );
    const filteredNumbers = numbers?.phone_numbers?.filter(
      number => number.integration === integrationId,
    );

    const categorisedNumbers: NumbersByEnvironment =
      filteredNumbers?.reduce((acc, number) => {
        const env =
          number.client_env === ClientEnvironment.PRE_RELEASE
            ? ROUTING_ENVIRONMENTS.PRE_RELEASE
            : number.client_env;

        if (!acc[env]) {
          acc[env] = [];
        }

        acc[env].push(number.number);

        return acc;
      }, {} as NumbersByEnvironment) ?? EMPTY_NUMBERS;

    return categorisedNumbers;
  };
